const jstz = require('jstimezonedetect/dist/jstz.min');
$(document).on('turbolinks:load', function () {
  $('#timezone_autocomplete').val(jstz.determine().name())
});
